import React from "react";

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  className = "",
}) => {
  return (
    <h2
      className={`text-[18px] font-medium font-rubik text-[#1a1a1a] md:text-[20px] ${className}`}
    >
      {children}
    </h2>
  );
};
